import React, { FC } from 'react';

import { range } from '../../../shared/lib/functional';

import {
  dateToDayInfo,
  subtractStartDays,
  addStartDays,
  DAY_MILLIS,
  DatePickerProps,
} from './DatePicker';
import { TextButton, InlineIcon } from '@spark-labs/avocado-ui';

const DAYS_PER_PAGE = 5;

export type DayDatePickerProps = DatePickerProps;

const DayDatePicker: FC<DayDatePickerProps> = ({
  startDate,
  selectedDate,
  onSelectedDateChange,
  onStartDateChange,
}) => {
  let startTime = startDate.getTime();
  let days = range(DAYS_PER_PAGE).map(i =>
    dateToDayInfo(new Date(startTime + i * DAY_MILLIS), selectedDate)
  );

  return (
    <div style={{ minHeight: 60 }} className="bg-blue-lighter flex justify-center items-center">
      <TextButton
        className="mr-auto ml-1"
        onClick={() => onStartDateChange(subtractStartDays(startDate, DAYS_PER_PAGE))}
      >
        <InlineIcon className="text-white text-2xl ml-3" name={'chevron-circle-left'} />
      </TextButton>
      {days.map((day, i) => (
        <TextButton
          key={i}
          style={{ width: 50, height: 50, margin: '0 2px' }}
          className={`text-white text-center rounded-full items-center flex flex-col justify-center
${day.selected ? 'bg-green' : ''}`}
          onClick={() => onSelectedDateChange(day.date)}
        >
          <div className="text-xxs">{day.dayOfWeek}</div>
          <div className="text-lg">{day.dayOfMonth}</div>
        </TextButton>
      ))}
      <TextButton
        className="ml-auto mr-1"
        onClick={() => onStartDateChange(addStartDays(startDate, DAYS_PER_PAGE))}
      >
        <InlineIcon className="text-white text-2xl mr-3" name="chevron-circle-right" />
      </TextButton>
    </div>
  );
};

export default DayDatePicker;
